import React, { Component } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import CBMediaQuery from '../../shared/CBMediaQuery';
import '../../../App.css';

import { getStyle } from '../../../utils/utils';
import CBInputField from '../../shared/form_components/CBInputField';
import CBTextAreaField from '../../shared/form_components/CBTextAreaField';

import {
  inviteToChainCareService as _inviteToChainCareService,
} from '../../../actions/chainActions';
import {
  getEmailValidator,
  getLengthValidator,
} from '../../../utils/validators';
import CBModal from '../../shared/CBModal';

class InviteToChainCareServiceModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      formData: {
        email: '',
        organization_name: '',
        business_id: '',
        title: props.t('inviteDefaultTitle'),
        text: props.t('inviteDefaultText'),
        chain: props.selectedChainId,
      },
      formValid: {
        email: false
      },
    };
  }

  componentDidMount = () => {
    const { formData } = this.state;
    const newState = {
      formData: {
        ...formData,
      },
    };

    this.setState(newState);
  };

  setIsValid = (name, isValid) => {
    const { formValid } = this.state;
    const newFormValid = {
      ...formValid,
      [name]: isValid,
    };

    this.setState({ formValid: newFormValid });
  };

  getIsValid = () => {
    const { formValid } = this.state;
    let isValid = true;
    Object.values(formValid).forEach(fieldIsValid => {
      if (!fieldIsValid) {
        isValid = false;
      }
    });
    return isValid;
  };

  updateFormState = changedObject => {
    const { formData } = this.state;
    const newFormData = Object.assign({}, formData);
    newFormData[changedObject.target] = changedObject.value;
    this.setState({ formData: newFormData });
  };

  submitForm = () => {
    const { formData } = this.state;
    const {
      closeModal,
      inviteToChainCareService,
    } = this.props;

    inviteToChainCareService(formData);

    closeModal();
  };

  render() {
    const { formData } = this.state;
    const {
      modalIsOpen,
      closeModal,
      afterOpenModal,
      t,
    } = this.props;

    return (
      <CBMediaQuery>
        {screenSize => (
          <CBModal
            modalIsOpen={modalIsOpen}
            afterOpenModal={afterOpenModal}
            closeModal={closeModal}
            title={t('inviteToChainCareServiceTitle')}
            descriptionText={t('inviteToChainCareServiceDescription')}
            cancelText={t('cancel')}
            submitText={t('send')}
            submitForm={this.submitForm}
            isValid={this.getIsValid()}
          >
            <div style={getStyle(screenSize, styles, 'bodyContainer')}>
              <CBInputField
                name='email'
                inputStyle={getStyle(screenSize, styles, 'input')}
                value={formData.email}
                placeholder=''
                type='email'
                onChange={this.updateFormState}
                validators={[getLengthValidator(1, 40), getEmailValidator()]}
                isValidCallback={this.setIsValid}
                labelText={t('invitationEmailLabel')}
                labelTextStyle={getStyle(screenSize, styles, 'inputLabelText')}
                noValidationOnChange
              />
              <CBInputField
                name='organization_name'
                inputStyle={getStyle(screenSize, styles, 'input')}
                value={formData.organization_name}
                placeholder=''
                onChange={this.updateFormState}
                validators={[getLengthValidator(1, 100)]}
                isValidCallback={this.setIsValid}
                labelText={t('invitationOrganizationNameLabel')}
                labelTextStyle={getStyle(screenSize, styles, 'inputLabelText')}
              />
              <CBInputField
                name='business_id'
                inputStyle={getStyle(screenSize, styles, 'input')}
                value={formData.business_id}
                placeholder=''
                onChange={this.updateFormState}
                validators={[getLengthValidator(9, 9)]}
                isValidCallback={this.setIsValid}
                labelText={t('invitationBusinessIdLabel')}
                labelTextStyle={getStyle(screenSize, styles, 'inputLabelText')}
              />
              <CBInputField
                name='title'
                inputStyle={getStyle(screenSize, styles, 'input')}
                value={formData.title}
                placeholder=''
                onChange={this.updateFormState}
                validators={[getLengthValidator(1, 160)]}
                isValidCallback={this.setIsValid}
                labelText={t('invitationTitleLabel')}
                labelTextStyle={getStyle(screenSize, styles, 'inputLabelText')}
              />
              <CBTextAreaField
                name='text'
                value={formData.text}
                onChange={this.updateFormState}
                labelText={t('invitationTextLabel')}
                labelTextStyle={getStyle(screenSize, styles, 'inputLabelText')}
                validators={[getLengthValidator(1, 5000)]}
                isValidCallback={this.setIsValid}
                validateOnInput
              />
            </div>
          </CBModal>
        )}
      </CBMediaQuery>
    );
  }
}

const styles = {
  default: {
    bodyContainer: {
      display: 'flex',
      flexDirection: 'column',
      padding: '16px 32px'
    },
    input: {
      backgroundColor: '#ebebeb',
      fontSize: 14,
      textAlign: 'center',
      resize: 'none',
      color: 'black',
      borderRadius: 100,
      height: 40,
      border: 'none',
      width: '100%',
    },
    inputLabelText: {
      color: 'black',
    }
  },
  small: {
    bodyContainer: {
      display: 'flex',
      flexDirection: 'column',
      padding: '16px 16px'
    }
  },
};

function mapStateToProps(state) {
  return {
    user: state.authUser.user,
  };
}

export default connect(
  mapStateToProps,
  {
    inviteToChainCareService: _inviteToChainCareService,
  },
)(translate('ChainCareService')(InviteToChainCareServiceModal));
